export const postMessageToWidget = (message: string, value?: string | number, origin?: string): void => {
    if (value !== undefined) {
        window.parent.postMessage(`${message}-${value}`, '*');
    } else {
        window.parent.postMessage(message, '*');
    }
};
